import {
	WeaTools
} from 'ecCom';

export const getOrgGroupSuggestForm = (params) => {
	return WeaTools.callApi('/api/hrm/group/getGroupSuggestForm', 'GET', params);
}

export const saveOrgGroupSuggest = (params) => {
	return WeaTools.callApi('/api/hrm/group/saveGroupSuggest', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/groupAdvice.js